// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.assignments-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  gap: 16px;
  flex-wrap: wrap;
}
.assignments-header .search-container {
  flex: 1 1;
  min-width: 300px;
}

.assignments-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
  padding: 20px;
}

.assignment-card {
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
  overflow: hidden;
  border: 1px solid #e0e0e0;
}
.assignment-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
.assignment-card__header {
  display: flex;
  align-items: center;
  padding: 16px;
  background: #f8f9fa;
  border-bottom: 1px solid #e0e0e0;
  gap: 12px;
}
.assignment-card__avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background: var(--m-primary);
  border-radius: 8px;
  color: white;
  flex-shrink: 0;
}
.assignment-card__title {
  flex: 1 1;
  min-width: 0;
}
.assignment-card__title h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.assignment-card__title p {
  margin: 4px 0 0 0;
  font-size: 13px;
  color: #666;
}
.assignment-card__actions {
  display: flex;
  gap: 4px;
  flex-shrink: 0;
}
.assignment-card__section {
  border-bottom: 1px solid #e0e0e0;
}
.assignment-card__section:last-child {
  border-bottom: none;
}
.assignment-card__section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: #fafafa;
  border-bottom: 1px solid #e0e0e0;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.assignment-card__section-header span {
  font-size: 13px;
  font-weight: 600;
  color: #555;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.assignment-card__section-header .collapse-button {
  background: var(--m-primary-subtle);
  border: none;
  padding: 6px 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--m-primary);
  transition: all 0.2s ease;
  border-radius: 6px;
}
.assignment-card__section-header .collapse-button:hover {
  background: var(--m-primary-subtle-hovered);
  transform: scale(1.05);
}
.assignment-card__section-header .collapse-button:active {
  transform: scale(0.95);
}
.assignment-card__list {
  overflow: hidden;
  transition: max-height 0.3s ease, opacity 0.3s ease;
}
.assignment-card__list.collapsed {
  max-height: 0;
  opacity: 0;
}
.assignment-card__list.expanded {
  max-height: 220px;
  min-height: 220px;
  height: 220px;
  opacity: 1;
  overflow-y: auto;
}
.assignment-card__list::-webkit-scrollbar {
  width: 6px;
}
.assignment-card__list::-webkit-scrollbar-track {
  background: #f1f1f1;
}
.assignment-card__list::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 3px;
}
.assignment-card__list::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.assignment-card__list-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
  transition: background 0.2s ease;
}
.assignment-card__list-item:last-child {
  border-bottom: none;
}
.assignment-card__list-item:hover {
  background: #f8f9fa;
}
.assignment-card__list-item svg {
  flex-shrink: 0;
  margin-top: 2px;
  color: var(--m-primary);
}
.assignment-card__list-item .list-item-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.assignment-card__list-item .list-item-content strong {
  font-size: 14px;
  color: #333;
  font-weight: 600;
}
.assignment-card__list-item .list-item-content .text-muted {
  font-size: 13px;
  color: #999;
}
.assignment-card__empty {
  padding: 20px 16px;
  text-align: center;
  color: #999;
  font-size: 14px;
  font-style: italic;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #666;
}
.loading-container .spin {
  animation: spin 1s linear infinite;
  color: var(--m-primary);
}
.loading-container p {
  margin-top: 16px;
  font-size: 16px;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #999;
}
.empty-state svg {
  color: #ddd;
}
.empty-state p {
  margin-top: 16px;
  font-size: 16px;
}

@media (max-width: 768px) {
  .assignments-grid {
    grid-template-columns: 1fr;
    padding: 12px;
  }
  .assignments-header {
    flex-direction: column;
    align-items: stretch;
  }
  .assignments-header .search-container {
    max-width: 100%;
  }
  .assignments-header button {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/views/pages/MachineAssignments/MachineAssignments.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AACF;AACE;EACE,SAAA;EACA,gBAAA;AACJ;;AAGA;EACE,aAAA;EACA,4DAAA;EACA,SAAA;EACA,aAAA;AAAF;;AAGA;EACE,mBAAA;EACA,kBAAA;EACA,wCAAA;EACA,yBAAA;EACA,gBAAA;EACA,yBAAA;AAAF;AAEE;EACE,0CAAA;AAAJ;AAGE;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,gCAAA;EACA,SAAA;AADJ;AAIE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,4BAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;AAFJ;AAKE;EACE,SAAA;EACA,YAAA;AAHJ;AAKI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;AAHN;AAMI;EACE,iBAAA;EACA,eAAA;EACA,WAAA;AAJN;AAQE;EACE,aAAA;EACA,QAAA;EACA,cAAA;AANJ;AASE;EACE,gCAAA;AAPJ;AASI;EACE,mBAAA;AAPN;AAWE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gCAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;AATJ;AAWI;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,yBAAA;EACA,qBAAA;AATN;AAYI;EACE,mCAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;AAVN;AAYM;EACE,2CAAA;EACA,sBAAA;AAVR;AAaM;EACE,sBAAA;AAXR;AAgBE;EACE,gBAAA;EACA,mDAAA;AAdJ;AAgBI;EACE,aAAA;EACA,UAAA;AAdN;AAiBI;EACE,iBAAA;EACA,iBAAA;EACA,aAAA;EACA,UAAA;EACA,gBAAA;AAfN;AAkBI;EACE,UAAA;AAhBN;AAmBI;EACE,mBAAA;AAjBN;AAoBI;EACE,gBAAA;EACA,kBAAA;AAlBN;AAoBM;EACE,gBAAA;AAlBR;AAuBE;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;EACA,gCAAA;AArBJ;AAuBI;EACE,mBAAA;AArBN;AAwBI;EACE,mBAAA;AAtBN;AAyBI;EACE,cAAA;EACA,eAAA;EACA,uBAAA;AAvBN;AA0BI;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAxBN;AA0BM;EACE,eAAA;EACA,WAAA;EACA,gBAAA;AAxBR;AA2BM;EACE,eAAA;EACA,WAAA;AAzBR;AA8BE;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;AA5BJ;;AAgCA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;AA7BF;AA+BE;EACE,kCAAA;EACA,uBAAA;AA7BJ;AAgCE;EACE,gBAAA;EACA,eAAA;AA9BJ;;AAkCA;EACE;IACE,uBAAA;EA/BF;EAiCA;IACE,yBAAA;EA/BF;AACF;AAkCA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;AAhCF;AAkCE;EACE,WAAA;AAhCJ;AAmCE;EACE,gBAAA;EACA,eAAA;AAjCJ;;AAsCA;EACE;IACE,0BAAA;IACA,aAAA;EAnCF;EAsCA;IACE,sBAAA;IACA,oBAAA;EApCF;EAsCE;IACE,eAAA;EApCJ;EAuCE;IACE,WAAA;EArCJ;AACF","sourcesContent":[".assignments-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  gap: 16px;\n  flex-wrap: wrap;\n\n  .search-container {\n    flex: 1;\n    min-width: 300px;\n  }\n}\n\n.assignments-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 20px;\n  padding: 20px;\n}\n\n.assignment-card {\n  background: #ffffff;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  transition: all 0.2s ease;\n  overflow: hidden;\n  border: 1px solid #e0e0e0;\n\n  &:hover {\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  }\n\n  &__header {\n    display: flex;\n    align-items: center;\n    padding: 16px;\n    background: #f8f9fa;\n    border-bottom: 1px solid #e0e0e0;\n    gap: 12px;\n  }\n\n  &__avatar {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 48px;\n    height: 48px;\n    background: var(--m-primary);\n    border-radius: 8px;\n    color: white;\n    flex-shrink: 0;\n  }\n\n  &__title {\n    flex: 1;\n    min-width: 0;\n\n    h3 {\n      margin: 0;\n      font-size: 16px;\n      font-weight: 600;\n      color: #333;\n      text-overflow: ellipsis;\n      overflow: hidden;\n      white-space: nowrap;\n    }\n\n    p {\n      margin: 4px 0 0 0;\n      font-size: 13px;\n      color: #666;\n    }\n  }\n\n  &__actions {\n    display: flex;\n    gap: 4px;\n    flex-shrink: 0;\n  }\n\n  &__section {\n    border-bottom: 1px solid #e0e0e0;\n\n    &:last-child {\n      border-bottom: none;\n    }\n  }\n\n  &__section-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 12px 16px;\n    background: #fafafa;\n    border-bottom: 1px solid #e0e0e0;\n    cursor: pointer;\n    user-select: none;\n\n    span {\n      font-size: 13px;\n      font-weight: 600;\n      color: #555;\n      text-transform: uppercase;\n      letter-spacing: 0.5px;\n    }\n\n    .collapse-button {\n      background: var(--m-primary-subtle);\n      border: none;\n      padding: 6px 8px;\n      cursor: pointer;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      color: var(--m-primary);\n      transition: all 0.2s ease;\n      border-radius: 6px;\n\n      &:hover {\n        background: var(--m-primary-subtle-hovered);\n        transform: scale(1.05);\n      }\n\n      &:active {\n        transform: scale(0.95);\n      }\n    }\n  }\n\n  &__list {\n    overflow: hidden;\n    transition: max-height 0.3s ease, opacity 0.3s ease;\n\n    &.collapsed {\n      max-height: 0;\n      opacity: 0;\n    }\n\n    &.expanded {\n      max-height: 220px;\n      min-height: 220px;\n      height: 220px;\n      opacity: 1;\n      overflow-y: auto;\n    }\n\n    &::-webkit-scrollbar {\n      width: 6px;\n    }\n\n    &::-webkit-scrollbar-track {\n      background: #f1f1f1;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background: #888;\n      border-radius: 3px;\n\n      &:hover {\n        background: #555;\n      }\n    }\n  }\n\n  &__list-item {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    padding: 12px 16px;\n    border-bottom: 1px solid #f0f0f0;\n    transition: background 0.2s ease;\n\n    &:last-child {\n      border-bottom: none;\n    }\n\n    &:hover {\n      background: #f8f9fa;\n    }\n\n    svg {\n      flex-shrink: 0;\n      margin-top: 2px;\n      color: var(--m-primary);\n    }\n\n    .list-item-content {\n      flex: 1;\n      display: flex;\n      flex-direction: column;\n      gap: 4px;\n\n      strong {\n        font-size: 14px;\n        color: #333;\n        font-weight: 600;\n      }\n\n      .text-muted {\n        font-size: 13px;\n        color: #999;\n      }\n    }\n  }\n\n  &__empty {\n    padding: 20px 16px;\n    text-align: center;\n    color: #999;\n    font-size: 14px;\n    font-style: italic;\n  }\n}\n\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  color: #666;\n\n  .spin {\n    animation: spin 1s linear infinite;\n    color: var(--m-primary);\n  }\n\n  p {\n    margin-top: 16px;\n    font-size: 16px;\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  color: #999;\n\n  svg {\n    color: #ddd;\n  }\n\n  p {\n    margin-top: 16px;\n    font-size: 16px;\n  }\n}\n\n// Responsive design\n@media (max-width: 768px) {\n  .assignments-grid {\n    grid-template-columns: 1fr;\n    padding: 12px;\n  }\n\n  .assignments-header {\n    flex-direction: column;\n    align-items: stretch;\n\n    .search-container {\n      max-width: 100%;\n    }\n\n    button {\n      width: 100%;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
